export const environment = process.env.NODE_ENV;
export const signature = process.env.REACT_APP_SIGNATURE;
export const appKey = process.env.REACT_APP_KEY;
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
